import { __decorate, __metadata } from "tslib";
import { DOCUMENT } from '@angular/common';
import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { SessionQuery, SessionService } from '@ho/shared/data-access/session';
import { AppEnvironment } from '@ho/shared/data-access/core/app-environment.model';
import { Observable } from 'rxjs';
let GuestUserGuard = class GuestUserGuard {
    constructor(_authQuery, _authService, _router, environment, document) {
        this._authQuery = _authQuery;
        this._authService = _authService;
        this._router = _router;
        this.environment = environment;
        this.document = document;
    }
    canActivate(route, state) {
        return Observable.create((observer) => {
            const userInfo = this._authQuery.userInfo();
            if (!!userInfo) {
                this._navigateUserToAppropriateApp(!!userInfo, observer);
            }
            else {
                observer.next(true);
                observer.complete();
            }
        });
    }
    _navigateUserToAppropriateApp(isAuthApp, observer) {
        if (!isAuthApp) {
            observer.next(true);
            observer.complete();
        }
        else {
            this._authService.switchApp();
            observer.next(false);
            observer.complete();
        }
    }
};
GuestUserGuard.ctorParameters = () => [
    { type: SessionQuery },
    { type: SessionService },
    { type: Router },
    { type: undefined, decorators: [{ type: Inject, args: [AppEnvironment,] }] },
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
GuestUserGuard = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SessionQuery,
        SessionService,
        Router, Object, Document])
], GuestUserGuard);
export { GuestUserGuard };
